import { render } from "./BizHomePage.vue?vue&type=template&id=69779482&scoped=true"
import script from "./BizHomePage.vue?vue&type=script&lang=js"
export * from "./BizHomePage.vue?vue&type=script&lang=js"

import "./BizHomePage.vue?vue&type=style&index=0&id=69779482&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69779482"]])

export default __exports__